module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1024-8e143e36e878a29a5abb48ec38aaebd6.png";